import PropTypes from "prop-types";
import React from "react";
import TextField from "@material-ui/core/TextField";

import withStyles from "@material-ui/core/styles/withStyles";

const style = theme => ({
  customInput: {
    backgroundColor: "#FAFAFA",
    borderRadius: 4,
    border: '1px solid #CCCCCC',
    fontSize: 16,
    height: '16px',
    padding: '10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    width: 'calc(100% - 24px)',
    '&:focus': {
      backgroundColor: theme.palette.common.white,
      borderColor: '#2684FF',
      boxShadow: '0 0 0 1px #2684FF',
    },
  },
});

const CustomInput = ({ classes, disabled, onChange, placeholder, startAdornment, type, value }) => (
  <TextField
    disabled={disabled}
    fullWidth
    InputProps={{
      classes: {
        input: classes.customInput,
      },
      disableUnderline: true,
      startAdornment,
    }}
    onChange={onChange}
    placeholder={placeholder}
    type={type}
    value={value}
  />
);

CustomInput.defaultProps = {
  disabled: false,
  placeholder: "",
  type: "text",
  startAdornment: undefined,
};

CustomInput.propTypes = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  startAdornment: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};

export default withStyles(style)(CustomInput);



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Input/Input.jsx